export const SET_SHOW_VALUE = 'SET_SHOW_VALUE'
export const setValueAction = (ShowState: any) => {
    return {
        type: SET_SHOW_VALUE,
        payload: {
            show: ShowState.show,
        }
    }
}   